import React, { FC, useCallback } from 'react'
import { scrollToTop } from '../../../../../utils/dom-utils'
import { StickyPopularContainer, FilterWrapper, BackToTopButton, ButtonText, MapWidgetContainer } from './styles'
import SearchResultListingPageStaticTransport from '../../../../../transports/search-result-listing-static-transport'
import { useTranslation } from '../../../../../hooks/locale'
import { MapWidgetBackground, MapButton, MapViewLabel } from '../../search-result-listing-content/styles'
import MapPinSrlIcon from '../../../../../assets/icons/map-pin-home.svg'
import { usePopularFilters } from '../../../../../redux/filters'
import Filter from '../../../../app-components/filter-sort-section/filter'

interface Props {
    filterStaticData: SearchResultListingPageStaticTransport
    isVisible: boolean
    onMapClick: (e: React.MouseEvent) => void
}

const StickyPopularFilters: FC<Props> = ({ filterStaticData, isVisible, onMapClick }) => {
    const { t } = useTranslation()

    const popularFilters = usePopularFilters(filterStaticData.filterSection.popularFilters)

    const handleBackToTop = useCallback(() => {
        scrollToTop()
    }, [])

    if (popularFilters.items.length === 0) {
        return null
    }

    return (
        <StickyPopularContainer isVisible={isVisible}>
            <MapWidgetContainer onClick={onMapClick}>
                <MapWidgetBackground />
                <MapButton>
                    <MapPinSrlIcon />
                    <MapViewLabel>{filterStaticData.mapView}</MapViewLabel>
                </MapButton>
            </MapWidgetContainer>

            <FilterWrapper>
                <Filter filter={popularFilters} filterStaticData={filterStaticData.filterSection} shouldCommit />
            </FilterWrapper>

            <BackToTopButton onClick={handleBackToTop}>
                <ButtonText>{t('searchResultListing.backToTop')}</ButtonText>
            </BackToTopButton>
        </StickyPopularContainer>
    )
}

export default StickyPopularFilters
